/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_Reason_No_PersonInputs */

const en_us2_body_assessment_pose_reason_no_person = /** @type {(inputs: Body_Assessment_Pose_Reason_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody showed up in the photo. Stand in front of the phone, about 2 m away, with your whole body in the frame.`)
};

const pt_br2_body_assessment_pose_reason_no_person = /** @type {(inputs: Body_Assessment_Pose_Reason_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não apareceu ninguém na foto. Fique na frente do celular, a uns 2 m, com o corpo inteiro no enquadramento.`)
};

const es_419_body_assessment_pose_reason_no_person = /** @type {(inputs: Body_Assessment_Pose_Reason_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No apareció nadie en la foto. Ponte frente al teléfono, a unos 2 m, con todo tu cuerpo en el encuadre.`)
};

const pt_pt2_body_assessment_pose_reason_no_person = /** @type {(inputs: Body_Assessment_Pose_Reason_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não apareceu ninguém na foto. Fica à frente do telemóvel, a uns 2 m, com o corpo inteiro no enquadramento.`)
};

const fr_fr2_body_assessment_pose_reason_no_person = /** @type {(inputs: Body_Assessment_Pose_Reason_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne n'apparaît sur la photo. Place-toi devant le téléphone, à environ 2 m, le corps entier dans le cadre.`)
};

const de_de2_body_assessment_pose_reason_no_person = /** @type {(inputs: Body_Assessment_Pose_Reason_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf dem Foto war niemand zu sehen. Stell dich etwa 2 m vor das Handy, mit dem ganzen Körper im Bild.`)
};

const it_it2_body_assessment_pose_reason_no_person = /** @type {(inputs: Body_Assessment_Pose_Reason_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nella foto non c'era nessuno. Mettiti davanti al telefono, a circa 2 m, con tutto il corpo nell'inquadratura.`)
};

/**
* | output |
* | --- |
* | "Nobody showed up in the photo. Stand in front of the phone, about 2 m away, with your whole body in the frame." |
*
* @param {Body_Assessment_Pose_Reason_No_PersonInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_reason_no_person = /** @type {((inputs?: Body_Assessment_Pose_Reason_No_PersonInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_Reason_No_PersonInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_reason_no_person(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_reason_no_person(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_reason_no_person(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_reason_no_person(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_reason_no_person(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_reason_no_person(inputs)
	return en_us2_body_assessment_pose_reason_no_person(inputs)
});
export { body_assessment_pose_reason_no_person as "body-assessment.pose_reason.no_person" }